import { gql } from '@apollo/client';

const GET_ACCOUNTING_INVOICES = gql`
  query accountingInvoices($where: [AccountingInvoiceWhereInput!]!) {
    accountingInvoices(where: $where) {
      name
      documentType
      language
      fileType
      size
      url
      id
      orderNumber
    }
  }
`;

export default GET_ACCOUNTING_INVOICES;
